import { isProdEnv } from '@gameday/common/functions/inProduction'
import withRecaptcha from '@gameday/common/functions/recaptcha'

import { auth } from '../constants/endpoints'

const withRecaptchaLocal = page => Component => {
  const siteKey = process.env.MYGAMEDAY_RECAPCHA_SITE_KEY
  const endpoint = `api/${auth.recaptcha}`
  return withRecaptcha(siteKey, page, endpoint, isProdEnv())(props => <Component {...props} />)
}

export default withRecaptchaLocal
